import { render, staticRenderFns } from "./EscalaConciencia.vue?vue&type=template&id=8fa81f42&"
import script from "./EscalaConciencia.vue?vue&type=script&lang=js&"
export * from "./EscalaConciencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports